import DataObjectMap from 'assets/components/dataObjectMap/DataObjectMap';
import { useModalForm } from 'assets/components/form/modalForm/ModalForm';
import FormatValue from 'assets/components/formatValue/FormatValue';
import Icon from 'assets/components/icon/Icon';
import NumberInput from 'assets/components/inputs/number/NumberInput';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import InputWrapper from 'assets/components/inputs/wrappers/InputWrapper';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import Theme from 'assets/themes/Theme.Common';
import { useSalesContractProvider } from '../../../Sales.Contract.Hooks';
import { ContractAdjustForm } from '../Contract.AdjustDistributions';

const ContractAdjustDistributionsDistributions = () => {
  const { lang } = getLocales();
  const { form } = useModalForm<ContractAdjustForm>();
  const { selected } = useSalesContractProvider();
  const { isDealer } = useAuthStore();

  /* TODO: Add if needed.
  function sumAll(distributions?: Utils.PricingDistribution) {
    return values(distributions).reduce((p, c) => p + c.amount, 0) ?? 0;
  }
  const isSameSum =
    sumAll(form.data.pricingDistributions) === sumAll(selected?.pricingDistributions) &&
    sumAll(form.data.distributorDistributions) === sumAll(selected?.distributorDistributions);
 */

  return (
    <>
      <p
        style={{
          backgroundColor: Theme.Color.warning,
          color: 'white',
          padding: `${Theme.Size.M} ${Theme.Size.L}`,
          fontWeight: 'bold',
        }}
      >
        {lang.contractUnrestrictedUpdateWarningMessage}
      </p>
      {/* TODO: Add if needed.
        !isSameSum && (
          <p
            style={{
              backgroundColor: Theme.Color.error,
              color: 'white',
              padding: `${Theme.Size.M} ${Theme.Size.L}`,
              fontWeight: 'bold',
            }}
          >
            Sum of changed prices need to match original sum!
          </p>
        )
        */}
      <FormWrapper>
        <InputWrapper>
          <NumberInput
            name="originalPriceCAD"
            value={form.data.originalPriceCAD}
            label={lang.originalPrice}
            onChange={form.update}
            icon={<Icon class={'fas-dollar-sign'} />}
            min={0}
            step={0.01}
            roundOnBlur
          />
          <NumberInput
            name="distributorPriceCAD"
            value={form.data.distributorPriceCAD}
            label={lang.distributorPrice}
            onChange={form.update}
            icon={<Icon class={'fas-dollar-sign'} />}
            min={0}
            step={0.01}
            roundOnBlur
          />
          <NumberInput
            name="discountPriceCAD"
            value={form.data.discountPriceCAD}
            label={lang.adjustedPrice}
            onChange={form.update}
            icon={<Icon class={'fas-dollar-sign'} />}
            min={0}
            step={0.01}
            roundOnBlur
          />
          <NumberInput
            name="salePriceCAD"
            value={form.data.salePriceCAD}
            label={lang.salePrice}
            onChange={form.update}
            icon={<Icon class={'fas-dollar-sign'} />}
            min={0}
            step={0.01}
            roundOnBlur
          />
          <NumberInput
            name="gstHst"
            value={Number(((form.data.gstHst || 0) * 100).toFixed(2))}
            label={'GstHst'}
            onChange={({ gstHst }) =>
              form.update({
                gstHst: gstHst * 0.01,
              })
            }
            icon={<Icon class={'fas-percentage'} />}
            step={0.01}
            roundOnBlur
          />
          <NumberInput
            name="provincialSalesTax"
            value={Number(((form.data.provincialSalesTax || 0) * 100).toFixed(2))}
            label={'Provincial Sales Tax'}
            onChange={({ provincialSalesTax }) =>
              form.update({
                provincialSalesTax: provincialSalesTax * 0.01,
              })
            }
            icon={<Icon class={'fas-percentage'} />}
            step={0.01}
            roundOnBlur
          />
        </InputWrapper>
      </FormWrapper>
      <table className={ThemeTableSimple}>
        <thead>
          <tr>
            <th>{lang.pricingDistributions}</th>
            <th>{lang.originalPrice}</th>
            <th>{lang.adjustedPrice}</th>
          </tr>
        </thead>
        <tbody>
          <DataObjectMap
            data={form.data.pricingDistributions}
            render={({ data: pricingInfo, key }) => {
              const old = selected.pricingDistributions[key];
              return (
                <tr key={key}>
                  <td>{key}</td>
                  <td>
                    <FormatValue value={`${(old?.amount ?? 0).toFixed(2)}$`} />
                  </td>
                  <td>
                    <NumberInput
                      name="amount"
                      value={pricingInfo.amount}
                      onChange={({ amount }) =>
                        form.update({
                          pricingDistributions: {
                            ...form.data.pricingDistributions,
                            [key]: {
                              ...pricingInfo,
                              amount,
                            },
                          },
                        })
                      }
                      style={{
                        formInput: {
                          minWidth: '157px',
                        },
                        input: {
                          textAlign: 'right',
                        },
                      }}
                      icon={<Icon class={'fas-dollar-sign'} />}
                      min={0}
                      step={0.01}
                      roundOnBlur
                    />
                  </td>
                </tr>
              );
            }}
          />
        </tbody>
        {!isDealer && (
          <>
            <thead>
              <tr>
                <th>{lang.distributorDistributions}</th>
                <th>{lang.originalPrice}</th>
                <th>{lang.adjustedPrice}</th>
              </tr>
            </thead>
            <tbody>
              <DataObjectMap
                data={form.data.distributorDistributions}
                render={({ data: pricingInfo, key }) => {
                  const old = selected.distributorDistributions[key];
                  return (
                    <tr key={key}>
                      <td>{key}</td>
                      <td>
                        <FormatValue value={`${(old?.amount ?? 0).toFixed(2)}$`} />
                      </td>
                      <td>
                        <NumberInput
                          name="amount"
                          value={pricingInfo.amount}
                          onChange={({ amount }) =>
                            form.update({
                              distributorDistributions: {
                                ...form.data.distributorDistributions,
                                [key]: {
                                  ...pricingInfo,
                                  amount,
                                },
                              },
                            })
                          }
                          style={{
                            formInput: {
                              minWidth: '157px',
                            },
                            input: {
                              textAlign: 'right',
                            },
                          }}
                          icon={<Icon class={'fas-dollar-sign'} />}
                          min={0}
                          step={0.01}
                          roundOnBlur
                        />
                      </td>
                    </tr>
                  );
                }}
              />
            </tbody>
          </>
        )}
      </table>
    </>
  );
};

export default ContractAdjustDistributionsDistributions;
